<div
  class="userlist__completeness"
  [class.userlist__completeness--compact]="compact"
  [attr.title]="tooltip()"
>
  <div class="userlist__completeness-head">
    <span
      class="userlist__completeness-dot"
      [class.userlist__completeness-dot--complete]="level() === 'complete'"
      [class.userlist__completeness-dot--few]="level() === 'few'"
      [class.userlist__completeness-dot--many]="level() === 'many'"
    ></span>
    <span class="userlist__completeness-percent">{{
      'userlist.completeness.profilePercent' | translate: { percent: percent() }
    }}</span>

    @if (badges() === 0) {
      <span class="userlist__completeness-clear">{{
        'userlist.completeness.noOpenBadges' | translate
      }}</span>
    } @else {
      <span class="userlist__completeness-count">
        <span class="userlist__completeness-badge">{{ badges() }}</span>
        <span class="userlist__completeness-badge-label">{{
          badgeLabel() | translate
        }}</span>
      </span>
    }
  </div>

  <div
    class="userlist__completeness-track"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuenow]="percent()"
    [attr.aria-label]="progressLabel()"
  >
    <span
      class="userlist__completeness-bar"
      [class.userlist__completeness-bar--complete]="level() === 'complete'"
      [class.userlist__completeness-bar--few]="level() === 'few'"
      [class.userlist__completeness-bar--many]="level() === 'many'"
      [style.width.%]="percent()"
    ></span>
  </div>
</div>
